const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={43} fill="none">
    <rect
      width={42}
      height={42}
      y={0.797}
      fill="var(--thankyou-verified-part-fill)"
      rx={21}
    />
    <path
      className="stroke-(--thankyou-verified-part)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="M23.25 20.356H27M23.25 23.237H27M17.635 23.237c1.242 0 2.25-.967 2.25-2.16s-1.008-2.16-2.25-2.16c-1.243 0-2.25.967-2.25 2.16s1.007 2.16 2.25 2.16Z"
    />
    <path
      className="stroke-(--thankyou-verified-part)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="M14.729 25.397a2.875 2.875 0 0 1 1.068-1.556 3.082 3.082 0 0 1 1.837-.604c.665 0 1.311.212 1.837.603s.902.939 1.068 1.557"
    />
    <path
      className="stroke-(--thankyou-verified-part)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="M29.25 14.597h-16.5c-.414 0-.75.322-.75.72v12.96c0 .397.336.72.75.72h16.5c.414 0 .75-.323.75-.72v-12.96c0-.398-.336-.72-.75-.72Z"
    />
  </svg>
)
export { SvgComponent as DocumentCircle }
